import { IRegion } from "../../interfaces";

export const RegionEmpty: IRegion = {
    id: "",
    name: "",  
  }; 